import { ScreenScrapeLoader } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeLoader';
import { ScreenScrapeStepTitle } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeStepTitle';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';

export const ScreenScrapeProcessing = () => {
  const ctx = useSSContext();

  return (
    <>
      <ScreenScrapeStepTitle>
        {ctx.lastJsonMessage?.value}
      </ScreenScrapeStepTitle>
      <ScreenScrapeLoader />
    </>
  );
};
